<!-- Modo Modal para captura de familiares - USA EL MISMO FORMULARIO COMPLETO -->
@if (familyMemberMode && isModalOpen()) {
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div
      class="bg-white rounded-lg w-11/12 max-w-6xl max-h-[95vh] overflow-y-auto shadow-xl"
    >
      <div
        class="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center z-10"
      >
        <h3 class="text-xl font-bold text-brand-tertiary m-0">
          {{ getModalTitle() }}
        </h3>
        <button
          type="button"
          (click)="closeModal()"
          class="text-gray-500 hover:text-gray-700 text-2xl font-bold"
        >
          ×
        </button>
      </div>

      <div class="p-6">
        <ng-container *ngTemplateOutlet="manualFormTemplate"></ng-container>
      </div>

      <div
        class="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end gap-4 z-10"
      >
        <button
          type="button"
          (click)="closeModal()"
          class="px-6 py-3 border-2 border-blue-deep text-blue-deep rounded-lg hover:bg-blue-50 transition-colors font-medium"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="saveFamilyMember()"
          class="px-6 py-3 bg-blue-deep text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Agregar Familiar
        </button>
      </div>
    </div>
  </div>
}

<!-- Modo Normal (página completa) -->
@if (!familyMemberMode) {
  <div
    class="preclinical flex flex-col w-full gap-6 py-6"
    [ngClass]="isModal ? 'bg-white' : 'bg-background-tertiary min-h-screen'"
  >
    <div class="header-section flex flex-col gap-6">
      <div class="flex flex-col gap-2">
        <h3 class="text-2xl font-bold text-brand-tertiary m-0">
          Ingreso Manual de Muestra
        </h3>
        <p class="text-sm text-text-secondary m-0">
          Complete todos los campos requeridos para registrar la muestra
          manualmente.
        </p>
      </div>
    </div>

    <div class="form-section bg-white rounded-lg p-6">
      <ng-container *ngTemplateOutlet="manualFormTemplate"></ng-container>

      <div class="flex justify-end gap-4 mt-6">
        <app-button
          [type]="ButtonTypeEnum.SECONDARY"
          [size]="ButtonSizeEnum.MD"
          (click)="cancelSample()"
        >
          Cancelar
        </app-button>

        <app-button
          [type]="ButtonTypeEnum.PRIMARY"
          [size]="ButtonSizeEnum.MD"
          (click)="saveManualSample()"
          [disabled]="!canSave()"
        >
          Guardar Muestra
        </app-button>
      </div>
    </div>
  </div>
}

<!-- Template reutilizable del formulario -->
<ng-template #manualFormTemplate>
  <form [formGroup]="sampleForm" class="flex flex-col gap-6">
    <div class="section-header">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Datos del Paciente
      </h4>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <app-form-dropdown
        [formControl]="identifierTypeControl"
        [items]="identifierTypeDropdownOptions"
        label="Tipo de Identificación"
        placeholder="Seleccione tipo"
      ></app-form-dropdown>

      <app-input-text
        [formControl]="idNumberControl"
        label="Número de Documento"
        placeholder="Ingrese número"
      ></app-input-text>

      <app-input-text
        [formControl]="givenNameControl"
        label="Nombres"
        placeholder="Ingrese nombres"
      ></app-input-text>

      <app-input-text
        [formControl]="middleNameControl"
        label="Segundo Nombre (opcional)"
        placeholder="Ingrese segundo nombre"
      ></app-input-text>

      <app-input-text
        [formControl]="familyNameControl"
        label="Primer Apellido"
        placeholder="Ingrese primer apellido"
      ></app-input-text>

      <app-input-text
        [formControl]="maternalFamilyNameControl"
        label="Segundo Apellido (opcional)"
        placeholder="Ingrese segundo apellido"
      ></app-input-text>

      <app-form-dropdown
        [formControl]="administrativeSexControl"
        [items]="administrativeSexDropdownOptions"
        label="Sexo"
        placeholder="Seleccione sexo"
      ></app-form-dropdown>

      <app-form-date
        [formControl]="birthDateControl"
        label="Fecha de Nacimiento"
      ></app-form-date>

      <app-input-text
        [formControl]="maritalStatusControl"
        label="Estado Civil"
        placeholder="Ingrese estado civil"
      ></app-input-text>

      <app-input-text
        [formControl]="emailAddressControl"
        label="Correo Electrónico (opcional)"
        placeholder="correo@ejemplo.com"
      ></app-input-text>

      <app-input-text
        [formControl]="telephoneNumberControl"
        label="Teléfono"
        placeholder="Ingrese teléfono"
      ></app-input-text>

      <app-input-text
        [formControl]="streetAddressControl"
        label="Dirección (opcional)"
        placeholder="Ingrese dirección"
      ></app-input-text>
    </div>

    <div class="section-header mt-6">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Datos de la Muestra
      </h4>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <app-form-dropdown
        [formControl]="specimenTypeControl"
        [items]="specimenTypeDropdownOptions()"
        label="Tipo de Muestra"
        placeholder="Seleccione tipo"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="specimenContainerIdControl"
        [items]="specimenContainerDropdownOptions()"
        label="Contenedor de Muestra"
        placeholder="Seleccione contenedor"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="priorityIdControl"
        [items]="priorityDropdownOptions()"
        label="Prioridad"
        placeholder="Seleccione prioridad"
      ></app-form-dropdown>
    </div>

    <div class="section-header mt-6">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Datos del Examen
      </h4>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <app-form-dropdown
        [formControl]="examTypeControl"
        [items]="examTypeDropdownOptions()"
        label="Tipo de Examen"
        placeholder="Seleccione examen"
      ></app-form-dropdown>
    </div>

    <div class="section-header mt-6">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Datos de la Orden
      </h4>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <app-form-dropdown
        [formControl]="companyIdControl"
        [items]="insuranceCompanyDropdownOptions()"
        label="Compañía de Seguros"
        placeholder="Seleccione compañía"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="providerIdControl"
        [items]="providerDropdownOptions()"
        label="Proveedor"
        placeholder="Seleccione proveedor"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="regionControl"
        [items]="regionDropdownOptions()"
        label="Región"
        placeholder="Seleccione región"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="siteControl"
        [items]="siteDropdownOptions()"
        label="Sede"
        placeholder="Seleccione sede"
      ></app-form-dropdown>

      <app-input-text
        [formControl]="placerOrderNumberControl"
        label="Número de Orden"
        placeholder="Ingrese número de orden"
      ></app-input-text>

      <app-input-text
        [formControl]="caseNumberInputControl"
        label="Número de Caso"
        placeholder="Ingrese número de caso"
      ></app-input-text>

      <app-form-dropdown
        [formControl]="laboratoriesIdControl"
        [items]="laboratoriesDropdownOptions()"
        label="Laboratorio de Referencia"
        placeholder="Seleccione laboratorio"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="diagnosesIdControl"
        [items]="diagnosesDropdownOptions()"
        label="Diagnóstico"
        placeholder="Seleccione diagnóstico"
      ></app-form-dropdown>

      <app-form-dropdown
        [formControl]="specialistsIdControl"
        [items]="specialistsDropdownOptions()"
        label="Especialista (opcional)"
        placeholder="Seleccione especialista"
      ></app-form-dropdown>
    </div>

    <div class="section-header mt-6">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Observaciones
      </h4>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <app-input-text-area
        [formControl]="userDataDescriptionControl"
        label="Observación de datos de usuario (opcional)"
        [rows]="3"
      ></app-input-text-area>

      <app-input-text-area
        [formControl]="clinicalHistoryControl"
        label="Resumen de historia clínica (opcional)"
        [rows]="3"
      ></app-input-text-area>

      <app-input-text-area
        [formControl]="descriptionDataSampleControl"
        label="Observación de datos de muestra (opcional)"
        [rows]="3"
      ></app-input-text-area>

      <app-input-text-area
        [formControl]="descriptionDataExamControl"
        label="Observación de datos del examen (opcional)"
        [rows]="3"
      ></app-input-text-area>
    </div>

    <div class="section-header mt-6">
      <h4 class="text-lg font-semibold text-brand-tertiary mb-4">
        Información Adicional
      </h4>
    </div>

    <div class="grid grid-cols-1 gap-4">
      <div class="flex items-center gap-4">
        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            formControlName="consentForUseOfSamples"
            class="form-checkbox h-5 w-5 text-brand-primary"
          />
          <span class="text-sm text-text-primary"
            >Consentimiento para uso de muestras</span
          >
        </label>

        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            formControlName="acmg"
            class="form-checkbox h-5 w-5 text-brand-primary"
          />
          <span class="text-sm text-text-primary">ACMG</span>
        </label>

        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            formControlName="mlpa"
            class="form-checkbox h-5 w-5 text-brand-primary"
          />
          <span class="text-sm text-text-primary">MLPA</span>
        </label>

        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            formControlName="prioritization"
            class="form-checkbox h-5 w-5 text-brand-primary"
          />
          <span class="text-sm text-text-primary">Priorización</span>
        </label>
      </div>

      <label class="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          formControlName="isReprocess"
          class="form-checkbox h-5 w-5 text-brand-primary"
        />
        <span class="text-sm text-text-primary">¿Es reproceso?</span>
      </label>

      @if (isReprocessChecked()) {
        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 p-4 bg-gray-50 rounded-lg"
        >
          <app-form-dropdown
            [formControl]="causeReprocessIdControl"
            [items]="causeReprocessDropdownOptions()"
            label="Causa de Reproceso"
            placeholder="Seleccione causa"
          ></app-form-dropdown>

          <app-form-dropdown
            [formControl]="statusReprocessIdControl"
            [items]="statusReprocessDropdownOptions()"
            label="Estado de Reproceso"
            placeholder="Seleccione estado"
          ></app-form-dropdown>
        </div>
      }
    </div>
  </form>
</ng-template>

<!-- Modal para agregar familiares (cuando el componente manual no está en modo familyMemberMode) -->
@if (!familyMemberMode) {
  <app-family-member-modal
    #familyMemberModal
    [identifierTypes]="identifierTypesForModal()"
    [examTypeInfo]="examTypeInfo()"
    [patientSex]="sampleForm.get('administrativeSex')?.value"
    (familyMemberAdded)="onFamilyMemberAdded($event)"
  ></app-family-member-modal>
}
